export default "__VITE_ASSET__xGYsS8sk__"